const env = process.env.REACT_APP_ENV;

const envValues = (() => {
  switch (env) {
    case 'staging':
      return {
        PORT: 80,
        REACT_APP_API_ENDPOINT: 'https://aware-healing-staging.up.railway.app/v1',
        REACT_APP_API_FRONT_END: 'https://aware-healing-staging.up.railway.app',
        REACT_APP_API_LANDING_PAGE: 'https://landing-marq.iscriptsdemo.com',
        REACT_APP_CLIENT: 'https://marq-events.iscriptsdemo.com',
        REACT_APP_API_PERMISSION_DENIED: 'https://aware-healing-staging.up.railway.app/permission',
        REACT_APP_SHOW_COOKIE_BOX: false,
        SOCKET_STATUS: 'OFF',
        COLLECTIONURL: process.env.REACT_APP_COLLECTIONURL,
      };
    case 'production':
      return {
        PORT: 80,
        REACT_APP_API_ENDPOINT: 'https://api.marqevents.com/v1',
        REACT_APP_API_FRONT_END: 'https://api.marqevents.com',
        REACT_APP_API_LANDING_PAGE: 'https://marqevents.com',
        REACT_APP_CLIENT: 'https://app.marqevents.com',
        REACT_APP_API_PERMISSION_DENIED: 'https://manage.marqevents.com/permission',
        REACT_APP_SHOW_COOKIE_BOX: false,
        SOCKET_STATUS: 'OFF',
        COLLECTIONURL: process.env.REACT_APP_COLLECTIONURL,
      };
    case 'development':
      return {
        PORT: 80,
        // REACT_APP_API_ENDPOINT: 'http://localhost:4080/v1',
        REACT_APP_API_ENDPOINT: 'https://welcoming-endurance-production-f7d6.up.railway.app/v1',
        REACT_APP_API_LANDING_PAGE: 'http://localhost:3000',
        REACT_APP_CLIENT: 'https://marq-events.iscriptsdemo.com',
        // REACT_APP_API_ENDPOINT: 'https://welcoming-endurance-production-f7d6.up.railway.app/v1',
        // REACT_APP_API_FRONT_END: 'http://localhost:4080',
        REACT_APP_API_FRONT_END: 'https://welcoming-endurance-production-f7d6.up.railway.app',
        REACT_APP_API_PERMISSION_DENIED: 'http://localhost:3000/permission',
        REACT_APP_SHOW_COOKIE_BOX: false,
        SOCKET_STATUS: 'OFF',
        COLLECTIONURL: process.env.REACT_APP_COLLECTIONURL,
      };
    case 'uat':
      return {
        PORT: 80,
        REACT_APP_API_ENDPOINT: 'https://api-uat.marqevents.com/v1',
        REACT_APP_API_FRONT_END: 'https://api-uat.marqevents.com',
        REACT_APP_API_LANDING_PAGE: 'https://landing-marq.iscriptsdemo.com',
        REACT_APP_API_PERMISSION_DENIED: 'https://api-uat.marqevents.com/permission',
        REACT_APP_SHOW_COOKIE_BOX: false,
        SOCKET_STATUS: 'OFF',
        COLLECTIONURL: process.env.REACT_APP_COLLECTIONURL,
      };
    default:
      return {
        PORT: 80,
        REACT_APP_API_ENDPOINT: 'http://localhost:4080/v1',
        REACT_APP_API_FRONT_END: 'https://welcoming-endurance-production-f7d6.up.railway.app',
        REACT_APP_API_LANDING_PAGE: 'http://localhost:3000',
        REACT_APP_CLIENT: 'http://localhost:3000',
        REACT_APP_API_PERMISSION_DENIED: 'http://localhost:3000/permission',
        REACT_APP_SHOW_COOKIE_BOX: false,
        SOCKET_STATUS: 'OFF',
        COLLECTIONURL: process.env.REACT_APP_COLLECTIONURL,
      };
  }
})();

export default envValues;
